$(function() {
  $("[data-open-item]").on("click", function() {
    $(".grid-item-more-info").css("display", "none");
    $("#" + $(this).attr("data-open-item")).css("display", "block");
  });
  
  $(".grid-item-more-info .drawer__close-button").on("click", function() {
    $(".grid-item-more-info").css("display", "none");
  });
  
  $(".desktop-toggle").on("click", function() {
    $(".collection__filters").toggle();
  });
  
  var $variants = $('.variant-model-size span');
  var $form = $('form[action="/cart/add"]');

  // Set the active variant on page load.
  setActiveVariantCustomFields($form, $variants);
  
  // Toggle display when dropdown changed in the "Add to Cart" feature.
  $form.change(function() {
      setActiveVariantCustomFields($form, $variants);
  });
  
  /**
   * Sets the active variant based on the "id" select dropdown in the add to cart form.
   */
  function setActiveVariantCustomFields($form, $variants){
    $variants.hide();
    setTimeout(function(){
      var active_variant_id = $form.find('select[name="id"]').val();
      $variants.filter('[data-variant-id="'+ active_variant_id +'"]').show();  
    }, 100);
  }

  $(".product-grid-item__swatch .swatch__element").click(function(){
    var v = $(this).data("handle");
    $(this).parent().find(".swatch__element").removeClass("active");
    $(this).addClass("active");
    $(this).parents(".product-grid-item").find(".product-grid-item__image-color").hide();
    $(this).parents(".product-grid-item").find(".product-grid-item__image-color.product-grid-item__image-"+v).show();

    var url = $(this).parents(".product-grid-item").find(".product-grid-item__image-color.product-grid-item__image-"+v).data("url");
    $(this).parents(".product-grid-item").find("a").attr("href", url);
  });
});